import { STEP_COOKIE_KEY } from "@/constants";
import { StepType, stepOrder } from "@/types/routes";
import { readStepCookie } from "@/utils/read-step-cookie";

/**
 * Client-side step cookie writes.
 *
 * The wizard step is persisted in a (non-httpOnly) cookie and read back
 * client-side via `readStepCookie`. Writing it here from the client — instead
 * of via a `"use server"` action — avoids the automatic RSC refetch that Next
 * triggers after every Server Action, which was re-running the entry page and
 * re-calling the backend (GET application + GET status) on every step.
 *
 * The server still reads the same cookie during SSR (`currentStep()`), so a
 * full reload resumes at the right step.
 */
const writeStepCookie = (step: StepType): void => {
	if (typeof document === "undefined") return;
	document.cookie = `${STEP_COOKIE_KEY}=${step}; path=/; SameSite=Lax`;
};

export const forwardStep = (): void => {
	const current = readStepCookie() ?? StepType.Landing;
	const nextIndex = Math.min(
		stepOrder.indexOf(current) + 1,
		stepOrder.length - 1
	);
	writeStepCookie(stepOrder[nextIndex]);
};

export const setStep = (step: StepType): void => {
	writeStepCookie(step);
};

export const clearStep = (): void => {
	if (typeof document === "undefined") return;
	document.cookie = `${STEP_COOKIE_KEY}=; path=/; max-age=0; SameSite=Lax`;
};
